import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const agenciesAdapter = createEntityAdapter();

const initialState = agenciesAdapter.addMany(
	agenciesAdapter.getInitialState({
		status: "idle",
		error: null,
	}),
	[
		{ id: 1, agency: "General Practitioner" },
		{ id: 2, agency: "Alcohol/Drug and other addiction services" },
		{ id: 3, agency: "Child and Adolescent" },
		{ id: 4, agency: "Mental Health Service" },
		{
			id: 5,
			agency: "Community Mental Health or Addition Service (adult services)",
		},
		{ id: 6, agency: "Cultural Support" },
		{ id: 7, agency: "DHB Social Worker" },
		{ id: 8, agency: "Disability Services" },
		{ id: 9, agency: "Family Start" },
		{ id: 10, agency: "Maternity Service/Lead" },
		{
			id: 11,
			agency: "Maternity Carer (If antenatal referral, what is the expected date of delivery?)",
		},
		{ id: 12, agency: "Plunket / Well Child /" },
		{ id: 13, agency: "Tamariki Ora" },
		{ id: 14, agency: "Police" },
		{ id: 15, agency: "Public Health Nurse" },
		{
			id: 16,
			agency: "Special Education / School Counsellor / SWISS / MASSIS",
		},
		{ id: 17, agency: "Children’s Team" },
		{
			id: 18,
			agency: "Other (e.g. Paediatrician, NGO social service (please specify))",
		},
	]
);

const agenciesSlice = createSlice({
	name: "agencies",
	initialState,
	reducers: {
		agencyUpserted(state, action) {
			agenciesAdapter.upsertOne(state, action.payload);
		},
		agencyRemoved(state, action) {
			agenciesAdapter.removeOne(state, action.payload);
		},
		agenciesReceived(state, action) {
			agenciesAdapter.setAll(state, action.payload);
		},
	},
});

export const { agenciesReceived, agencyUpserted, agencyRemoved } =
	agenciesSlice.actions;

export const { selectAll: selectAllAgencies, selectById: selectAgencyById } =
	agenciesAdapter.getSelectors((state) => state.roc.agencies);

export default agenciesSlice.reducer;
